import { render, staticRenderFns } from "./NewsItem .vue?vue&type=template&id=3e45da8d&scoped=true"
import script from "./NewsItem .vue?vue&type=script&lang=ts"
export * from "./NewsItem .vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45da8d",
  null
  
)

export default component.exports